import {Spinner} from '@gwc/core'
import clsx from 'clsx'
import React from 'react'

import {Grid} from '../../grid'
import {classes} from './Loader.classes'

type Props = {
  maxHeight?: boolean
}

const Loader: React.FC<Props> = ({maxHeight}) => (
  <Grid
    alignItems="center"
    className={clsx(classes.root, maxHeight && classes.maxHeight)}
    justify="center"
    spacing={3}
    wrap="nowrap"
    container
  >
    <Grid item>
      <Spinner />
    </Grid>
  </Grid>
)

export default Loader
